import type { Route } from "./+types/$locale._index";
import { buildSeoMeta } from "@/components/seo/meta";
import { Home } from "@/features/home";

/**
 * Home route (`/:locale/`).
 *
 * No loader: the Home page is fully static today — its only would-be data
 * dependency (`<HeroProductPreview>`) was removed from the render tree when
 * the hero was redesigned around `<SearchWidget>`. Until that section comes
 * back, there's nothing to prefetch.
 *
 * The `meta` export below is the source of truth for SEO tags on this page.
 */

export function meta({ params }: Route.MetaArgs) {
    const locale = (params.locale as string) ?? "en";
    return buildSeoMeta({
        title: "Baby Equipment Rentals — Strollers, Cribs & Car Seats",
        description:
            "Rent premium baby equipment by the day, week or month. Clean, safe strollers, cribs, and car seats delivered for travel or everyday family life.",
        path: "/",
        keywords:
            "baby equipment rental, stroller rental, crib rental, car seat rental, baby gear hire, travel baby equipment",
        // TODO Phase 6: hydrate availableLocales from root loader manifest
        locale,
        availableLocales: [{ code: "en" }],
    });
}

export default function HomeRoute() {
    return <Home />;
}
